// import {xxApi} from '@/api'
import { addShopping, getShoppingCount } from '@/api/shoppingCar';

const actions = {
  // 发送消息
  async acSetMessage({ commit, state, rootState, rootGetters }, params) {
    commit('muSetMessage', 'Hello!!');
  },

  // 加购
  async acAddShopping({ commit, state, rootState, rootGetters }, params) {
    try {
      // const res = await addShopping(params);
      commit('muSetShoppingCartCount');
    } catch (error) {

    }
  },
  async acGetShoppingCount({ commit, state, rootState, rootGetters }) {
    try {
      const res = await getShoppingCount();
      commit('muSetShoppingCartCount', res.data);
    } catch (error) {

    }
  },
};
export default actions;
